import { ReactElement } from 'react';

import styles from './LevelBar.module.scss';

const LevelBar = ({
  max,
  value,
  color,
}: {
  max: number;
  value: number;
  color: string;
}): ReactElement => {
  const step = 100 / max;
  const width = Math.abs(step * value);
  const left = value < 0 ? `calc(50% - ${width}%)` : '50%';

  return (
    <div className={styles.container} aria-hidden="true">
      <div
        className={styles.indicator}
        style={{
          width: `${width}%`,
          backgroundColor: color,
          left,
        }}
      />
    </div>
  );
};

export default LevelBar;
